﻿import Macy from "../macy.js";

document.addEventListener('DOMContentLoaded', () => {
    // init Macy for the legacy Guides homepage
    if (document.getElementById("grid")) {
        const articlegrid = new Macy({
            container: "#grid",
            trueOrder: false,
            waitForImages: false,
            useOwnImageLoader: false,
            mobileFirst: false,
            columns: 2,
            margin: 30,

            breakAt: {
                960: {
                    margin: 20
                },
                600: {
                    columns: 1
                }
            }
        });

        articlegrid.reInit();
        articlegrid.recalculate();
    }
});